<style lang="stylus" scoped>
@import '../cardMap.stylus';

.map-card-cont .map-card-lib:nth-child(even) {
  background: #F8F8F8;
}

.map-card {
  border: 1px solid #ccc;
  border-top none;
}

.map-card-cont .map-card-tonnage {
  background: rgba(240, 255, 253, 1) !important;
}
.tabtitle{
  display:flex;
  padding: 20px;
  position absolute;
  flex-direction: row-reverse;
  top 10px;
  right 20px;
  border: 1px solid #ccc;
  border-bottom none;
  width 342px;
  color: rgba(153, 153, 153, 1);
  font-size 15px;
}
</style>
<template>
  <div>
    <div class="tabtitle">
      <div style="width: 140px;text-align: right;">按车辆运营省</div>
      <div  >按车辆注册省</div>
    </div>
    <div class="map-card">
      <div class="map-card-cont" style="top:0;">
        <div
          class="map-card-lib"
          style="margin-top:0;border:0;border-radius:0;"
          v-for="(it,index) in cardItem"
          :key="index"
          :class="index == indexA?'map-card-tonnage':''"
          @click="active(index,it.registProvince,it.registProvcode)"
        >
          <div class="_lib1">{{it.name}}</div>
          <div class="_lib3">
            <span >{{format(it.value)}}辆</span>
            <span style="width: 140px;text-align: right;display: inline-block;">{{format(it.yyValue)}}辆</span>
          </div>
        </div>
        <rightBox v-if="cardItem.length==0"/>
      </div>
    </div>
  </div>
  
</template>

<script>
import allData from '../index.js'
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
import storage from '@/utils/storage'
export default {
  name: 'mapCard',
  data() {
    return {
      indexA: 0
    }
  },
  props: {
    cardItem: {
      default: () => {
        return allData.list
      },
      type: Array
    },
  },
   computed: {
    
  },
   mounted() {
    if(Cookies.get('userType')==2){
      let alsit = storage.get('areaList')
      this.active(1,alsit[0].provinceName,alsit[0].provinceCode);
    }
  },
  methods: {
    format(num) {
      if(num==null||num==undefined)return 0;
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
    active(index,name,registProvcode) {
      let that = this
      that.indexA = index
      this.$emit("getDetails",index,name,registProvcode)
    }
  }
}
</script>


